
import { mapActions } from 'vuex'
import { fromDob } from '~/util/date'

export default {
    props: {
        mode: {
            type: String,
            default: 'page',
        },
        merge: {
            type: Object,
            default: () => ({}),
        },
    },

    data () {
        return {
            form: {
                first_name: null,
                preferred_name: null,
                last_name: null,
                email: null,
                dob: null,
                password: null,
                password_confirm: null,
                newsletter: false,
            }
        }
    },
    computed: {
        dobx () {
            return fromDob(this.form.dob) || {}
        },
        age () {
            return this.dobx.age
        },
        isPage () {
            return this.mode === 'page'
        },
        isInline () {
            return this.mode === 'inline'
        },
        isModal () {
            return this.mode === 'modal'
        }
    },
    mounted () {
        this.form = {
            ...this.form,
            ...this.merge
        }
    },
    methods: {
        ...mapActions(['register']),
        validate () {
            return this.$validator.validate()
        },
        async submit () {
            if (await this.validate()) {
                const resp = await this.register({
                    ...this.form,
                    redirectTo: this.isPage ? this.$route.query.r ? decodeURIComponent(this.$route.query.r) : '/' : false
                })
                if (!resp?.error) {
                    this.$emit('registered', resp?.user)
                }
                return resp
            }
        }
    }
}
